import {Component, OnInit, ViewChild} from '@angular/core';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {ManagementLevel} from 'shared/models/target-groups/management-level';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {ManagementLevelService} from './services/management-level.service';

@Component({
  selector: 'management-level',
  templateUrl: './management-level.component.html',
  styleUrls: ['./management-level.component.css'],
})

export class ManagementLevelComponent implements OnInit {
  public allManagementLevel: Array<ManagementLevel> = [];
  public filteredManagementLevel: Array<ManagementLevel>;
  public fieldsToSearch: Array<Array<String>> = [];
  public newManagementLevelName: String;
  public searchTerm: String;
  public currentPage: Event;
  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private managementLevelService: ManagementLevelService) { }

  public ngOnInit(): void {
    this.getAllManagementLevel();
  }

  private showDeleteModal(id: number): void {
    const content: string = `Sind Sie wirklich sicher, dass Sie dieses Management Level löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(id)
      .show();
  }

  public getAllManagementLevel(): void {
    this.managementLevelService.getAllManagementLevel()
      .subscribe((allManagementLevel: Array<ManagementLevel>) => {
        this.allManagementLevel = allManagementLevel;
        this.filteredManagementLevel = allManagementLevel;
        this.prepareFieldsToSearch();
      });
  }

  public createManagementLevel(): void {
    this.managementLevelService.createManagementLevel(this.newManagementLevelName)
      .subscribe((createdManagementLevel: ManagementLevel) => {
        this.getAllManagementLevel();
      });
  }

  public updateManagementLevel(managementLevel: ManagementLevel): void {
    this.managementLevelService.updateManagementLevel(managementLevel)
      .subscribe((updatedManagementLevel: ManagementLevel) => {
        this.getAllManagementLevel();
      });
  }

  public deleteManagementLevel(managementLevel: ManagementLevel): void {
    this.managementLevelService.deleteManagementLevel(managementLevel)
      .subscribe((response: boolean) => {
        this.getAllManagementLevel();
      });
  }

  public filterManagementLevel(eventManagementLevel: Array<ManagementLevel>): void {
    this.filteredManagementLevel = eventManagementLevel;
  }

  private prepareFieldsToSearch(): void {
    this.allManagementLevel.forEach((managementLevel: ManagementLevel) => {
      this.fieldsToSearch.push([
        managementLevel.name.toLowerCase(),
      ]);
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/management-level/management-level.component.ts